module.exports = __webpack_public_path__ + "static/media/path0303.787f19dd.jpg";